import { Paper } from "@mui/material";
import dayjs from "dayjs";
import { FormProvider, useForm } from "react-hook-form";
import { useParams } from "react-router-dom";
import Skeletons from "../../../../../../components/loader/Skeletons";
import { POST_NON_WORKING_DATE } from "../../../../../../enums/ApiPaths";
import { WORKING_HOURS_TABLE } from "../../../../../../enums/QueryKeys";
import NonWorkingDatesForm from "../form/NonWorkingDatesForm";
import NonWorkingDayDeleteForm from "../form/NonWorkingDayDeleteForm";
import usePutWorkingHours from "../hooks/usePutWorkingHours";

export default function NonWorkingDatesList({ nonWorkingDates, fetch }) {
  const { id: clinicId } = useParams();
  const methods = useForm();
  const path = POST_NON_WORKING_DATE + clinicId;
  const submittion = usePutWorkingHours(path, WORKING_HOURS_TABLE);

  const transformData = (data) => {
    return {
      date: dayjs(data?.date).format("DD/MM/YYYY"),
      isWorkingDay: false,
      id: null,
    };
  };

  function submitData() {
    const data = methods.getValues();
    const transformedData = transformData(data);
    submittion.submitCallback(transformedData);
    methods.reset();
  }

  const withoutDaySorted = nonWorkingDates?.sort((a, b) => {
    const format = "DD/MM/YYYY";
    const dateA = dayjs(a.date, format);
    const dateB = dayjs(b.date, format);
    return dateA.isBefore(dateB) ? -1 : dateA.isAfter(dateB) ? 1 : 0;
  });

  const nonWorkingDatesSet = nonWorkingDates?.map((val) => val?.date)

  if (fetch?.loading) {
    return <Skeletons numOfSkeletons={6} height={50} />;
  }

  return (
    <Paper sx={{p:2}}>
      <FormProvider {...methods}>
        <form onSubmit={methods.handleSubmit(submitData)}>
          <NonWorkingDatesForm
            nonWorkingDate={nonWorkingDatesSet}
            key={"add-new-non-working-day"}
            submitData={submitData}
          />
        </form>
        {withoutDaySorted?.map((date) => (
            <NonWorkingDayDeleteForm date={date} key={date?.id} />
          ))}
      </FormProvider>
    </Paper>
  );
}
